import React from 'react';
import { useTranslation } from 'react-i18next';
import SubscriptionCard from '../../components/cards/subscription-card';
import { useOrganizationSettingsStore } from '../../store/organizationSettingsStore';
import { DiggerPlanEnum } from '../../components/enums/DiggerPlanEnum';
import { useChangePayment } from '../../apiHooks/mutations/changePayment/changePayment';

const Subscription = () => {
  const { t } = useTranslation();
  const { productId } = useOrganizationSettingsStore((state) => state.organizationSettings);
  const { mutate: changePayment } = useChangePayment();

  return (
    <div className="rounded-lg border border-dark bg-white px-[30px] py-[20px]">
      <div className="flex w-full items-center justify-between border-b-2 leading-[1.5]">
        <div className="flex flex-col">
          <span className="my-3 text-[22px] font-semibold text-primary">{t('manageYourSubscription')}</span>
          <p className="pb-3 text-xs text-[#BDBDBD]">
            {t('manageYourSubscriptionText')}
          </p>
        </div>
        <button
          onClick={() => {
            changePayment();
          }}
          className="h-[37px] w-[185px] rounded-l border text-sm text-primary"
        >
          {t('changeSubscription')}
        </button>
      </div>
      <div
        className="small-scroll relative mx-auto flex max-w-[1280px] items-center gap-5 overflow-x-auto overflow-y-hidden
          px-2"
      >
        <SubscriptionCard
          title="standardPlan"
          description="bestForEmergingBusinesses"
          price={500}
          buttonText="chooseStandard"
          color="yellow"
          isActive={productId === DiggerPlanEnum.standard}
          priceId="pri_01jc3h3z5hks1s9szfhrpjrptz"
          features={[
            'allSourceConnections',
            'basicReportsPlus',
            'limitedAdSpend',
            'limitedConversions',
          ]}
        />
        <SubscriptionCard
          title="proPlan"
          price={1500}
          description="bestForGrowingBusinesses"
          buttonText="chooseProfessional"
          color="green"
          isActive={productId === DiggerPlanEnum.pro}
          priceId="pri_01jc3h5nrsx4s290zgvnv62v0z"
          featureInclusionText="everythingIncludedInStandardPlus"
          features={[
            'advancedReporting',
            'connectToOneCRM',
            'offlineConversionReporting',
            'limitedAdSpend',
            'unlimitedConversions',
            'unlimitedActiveAds',
          ]}
        />
        <SubscriptionCard
          title="enterPrisePlan"
          description="bestForLargeOrganizations"
          buttonText="talkToUs"
          color="primary"
          isActive={productId === DiggerPlanEnum.enterprise}
          featureInclusionText="everythingIncludedInProPlus"
          features={[
            'unlimitedLeads',
            'unlimitedTraffic',
            'connectToMultipleCRM',
            'unlimitedDomains',
            'quarterlyReviews',
            'dedicatedSuccessManager',
            'supportEmailPhone',
          ]}
        />
      </div>
    </div>
  );
};

export default Subscription;
